import * as React from "react";
import type { SVGProps } from "react";
const SvgSheetWithText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={84}
    height={61}
    fill="none"
    viewBox="0 0 84 61" {...props}
  >
    <g opacity={0.6}>
      <path
        fill="url(#sheet-with-text_svg__a)"
        d="M29.76 11.347 3.71 34.034c-1.475 1.288-1.122 3.656.664 4.446l48.988 22.104a4.64 4.64 0 0 0 5.173-.914l24.723-24.14a2.11 2.11 0 0 0-.603-3.428L35.038 10.579a4.95 4.95 0 0 0-5.277.768"
      />
      <path
        fill="url(#sheet-with-text_svg__b)"
        d="M33.064 12.617c.516 0 .935-.307.935-.685s-.419-.686-.935-.686-.935.307-.935.686c0 .378.419.685.935.685"
      />
      <path
        fill="url(#sheet-with-text_svg__c)"
        d="M35.474 13.652c.516 0 .935-.306.935-.685s-.419-.686-.935-.686-.935.307-.935.686c0 .378.419.685.935.685"
      />
      <path
        fill="url(#sheet-with-text_svg__d)"
        d="M37.842 14.692c.517 0 .935-.308.935-.686s-.418-.686-.935-.686c-.516 0-.934.307-.934.686 0 .378.418.685.934.685"
      />
    </g>
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="2.05 2.05"
      strokeMiterlimit={10}
      strokeWidth={0.8}
      d="M28.214 6.71 2.162 29.397c-1.475 1.288-1.122 3.656.665 4.446l48.988 22.104a4.64 4.64 0 0 0 5.173-.914l24.722-24.14a2.11 2.11 0 0 0-.602-3.428L33.49 5.942a4.95 4.95 0 0 0-5.277.768Z"
    />
    <path
      fill="#00217B"
      d="M31.517 7.977c.517 0 .935-.307.935-.686s-.418-.686-.935-.686c-.516 0-.934.307-.934.686s.418.686.934.686M33.927 9.016c.517 0 .935-.307.935-.686s-.418-.685-.935-.685c-.516 0-.935.306-.935.685s.419.686.935.686M36.296 10.055c.516 0 .935-.307.935-.686 0-.378-.419-.685-.935-.685s-.935.307-.935.685.419.686.935.686"
    />
    <path
      stroke="#B0D2FF"
      strokeLinecap="round"
      strokeWidth={1.547}
      d="m27.806 16.082 8.249 3.866"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="2.05 2.05"
      strokeMiterlimit={10}
      strokeWidth={0.8}
      d="M27.183 1.554 1.131 24.241c-1.475 1.288-1.122 3.656.665 4.445l48.988 22.105a4.64 4.64 0 0 0 5.173-.914l24.722-24.14a2.11 2.11 0 0 0-.603-3.428L32.46.786a4.95 4.95 0 0 0-5.277.768Z"
    />
    <path
      stroke="#B0D2FF"
      strokeLinecap="round"
      strokeWidth={1.547}
      d="m26.775 10.926 8.249 3.866M42.757 39.797l8.248 3.866M23.682 15.05 61.316 32.58M20.074 18.66l37.633 17.528M16.465 22.266l37.634 17.528"
    />
    <defs>
      <linearGradient
        id="sheet-with-text_svg__a"
        x1={2.782}
        x2={83.616}
        y1={35.59}
        y2={35.59}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="sheet-with-text_svg__b"
        x1={32.129}
        x2={33.993}
        y1={11.932}
        y2={11.932}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="sheet-with-text_svg__c"
        x1={34.539}
        x2={36.403}
        y1={12.967}
        y2={12.967}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="sheet-with-text_svg__d"
        x1={36.907}
        x2={38.771}
        y1={14.006}
        y2={14.006}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSheetWithText;
